import { FieldUpdate } from './reducer';

export const getBasicInfoUpdateForField = (basicInfo: FieldUpdate, name: string) => {
    return basicInfo[name];
};
